import axios from 'axios';
import { useEffect, useState } from 'react';
import { getKwpAccessToken } from 'src/pages/settings/components/interfaces/kwp/components/helpers';

export const useCheckIfTokenIsValid = (userLink: string) => {
  const [isTokenValid, setValid] = useState(true);

  const token = getKwpAccessToken();
  const url = `${userLink}/api/Adresse/LoadAdressKomplett`;

  const checkIsTokenValid = () => {
    if (token !== null) {
      return axios
        .get(url, {
          headers: {
            accept: 'text/plain',
            'x-kwp-version': '1',
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => {
          setValid(true);
        })
        .catch((err: any) => {
          if (err.response?.status === 401) {
            setValid(false);
          } else if (err.response?.status === 404) {
            setValid(true);
          }
        });
    } else {
      setValid(false);
    }
  };

  useEffect(() => {
    checkIsTokenValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userLink]);

  return {
    isTokenValid,
  };
};
